import React from 'react';
import { inrToUsd, toLocalePrice, toLocalePriceNoDecimal } from '../../../utils/StringUtil';

const DataCard = ({ value, label, showCurrency = false, currencySymbol, currency, inrAgainstUsd }) => {
  const isLoading = value === undefined || value === null;

  return (
    <div className="col" style={{ width: "33%" }}>
      <div className="card bg-white py-3 rounded-lg shadow-md flex-fill " >
        <div className="card-body d-flex flex-column justify-content-center">
          {isLoading ? (
            <div>
              <div style={{
                backgroundColor: '#e0e0e0',
                height: '24px',
                width: '75%',
                borderRadius: '4px',
                marginBottom: '12px',
              }} />
              <div style={{
                backgroundColor: '#f0f0f0',
                height: '16px',
                width: '50%',
                borderRadius: '4px',
              }} />
            </div>
          ) : (
            <>
              <h2 className="card-title text-center text-primary mb-0">
                {showCurrency
                  ? currency === 'INR'
                    ? `${currencySymbol}${toLocalePriceNoDecimal(value)}`
                    : `${currencySymbol}${toLocalePrice(
                      inrToUsd(value, inrAgainstUsd, currency),
                      'en-US',
                      currency
                    )}`
                  : value}
              </h2>
              <p className="card-text text-center fw-bold small mt-2">
                {label}
              </p>
            </>
          )}
        </div>
      </div>
    </div>

  );
};

export default DataCard;
